var regSetPassController = {
    elForm: $('#regSetPassForm'),
    regModalSetPass: $('#regModalSetPass'),
    pass: '',
    init: function()
    {
        regSetPassController.elForm.find('.error-text').hide();
        regSetPassController.pass = regSetPassController.elForm.find('.js-input-pass').val();

        regSetPassController.elForm.on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();

                return false;
            }
        });

        regSetPassController.elForm.find('.js-input-pass').on('click change keyup blur input', function() {
            regSetPassController.pass = $(this).val().trim();
        });

        regSetPassController.elForm.find('button').on('click', function() {
            regSetPassController.submitForm();

            return false;
        });
    },
    submitForm: function()
    {
        if (!regSetPassController.validateForm()) {
            regSetPassController.showError();

            return false;
        }

        $.post(
            regSetPassController.elForm.attr('action'),
            regSetPassController.elForm.serialize(),
            function(data) {
                if (data.success) {
                    window.location.href = URL_CONST.LOGIN_REDIRECT;
                } else {
                    if(data.message) {
                        regSetPassController.elForm.find('.error-text').text(data.message);
                        regSetPassController.showError();
                    }
                }
            }, 'json');
    },
    validateForm: function()
    {
        regSetPassController.clearForm();
        var regex = /^\S{6,}$/;
        return (regSetPassController.pass.length > 5 && regex.test(regSetPassController.pass));
    },
    clearForm: function()
    {
        regSetPassController.elForm.find('.form-group').removeClass('has-error');
        regSetPassController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        regSetPassController.elForm.find('.form-group').addClass('has-error');
        regSetPassController.elForm.find('.error-text').show();
    }
};

$(function(){
    regSetPassController.init();
});